import { CaseReducer, createReducer } from "@reduxjs/toolkit";
import { Reducer } from "redux";
import { RemoteResource } from "../common/fetchable";
import {
  EmptyFetchable,
  Fetchable,
  FetchableError,
  FetchableSuccess,
  isFetchableError,
} from "../common/fetchable/helpers";
import { AuthActions } from "./actions";
import { AuthDTO } from "./models/dto";

export namespace Auth {
  export const login: RemoteResource<
    AuthDTO.Responses.Login.T,
    AuthDTO.Responses.Login.T,
    AuthDTO.Requests.AuthRequest.T
  > = {
    fetch: AuthActions.authRequest,
    updateStore: AuthActions.authDone,
    selector: (store) => store.auth.login,
  };
}
export interface AuthState {
  login: Fetchable<AuthDTO.Responses.Login.T>;
  redirectUrl?: string;
}

const initialAuthState: AuthState = {
  login: EmptyFetchable,
};

const loginResponse: CaseReducer<
  AuthState,
  {
    type: AuthActions.ActionTypes;
    payload: FetchableSuccess<AuthDTO.Responses.Login.T> | FetchableError;
  }
> = (state, action) => {
  if (isFetchableError(action.payload)) {
    state.login = action.payload;
  } else {
    state.login = {
      status: "ready",
      data: action.payload.data,
    };
  }
};

// Reducer
export const authReducer: Reducer<
  AuthState,
  AuthActions.Actions
> = createReducer(initialAuthState, (builder) => {
  builder
    .addCase(AuthActions.authRequest, (state) => {
      state.login = {
        status: "loading",
      };
    })
    .addCase(AuthActions.authDone, loginResponse)
    .addCase(AuthActions.clearAuthState, (state) => {
      state.login = EmptyFetchable;
    })
    .addCase(AuthActions.setRedirectUrl, (state, action) => {
      state.redirectUrl = action.payload;
    });
});
